export default "__VITE_ASSET__DSnx0fQi__"